import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=7130a709&scoped=true&"
import script from "./SocialLinks.vue?vue&type=script&lang=ts&"
export * from "./SocialLinks.vue?vue&type=script&lang=ts&"
import style0 from "./SocialLinks.vue?vue&type=style&index=0&id=7130a709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130a709",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSocialFacebook: require('/var/www/packages/theme/components/icons/social/Facebook.vue').default,IconsSocialInstagram: require('/var/www/packages/theme/components/icons/social/Instagram.vue').default,IconsSocialYoutube: require('/var/www/packages/theme/components/icons/social/Youtube.vue').default,IconsSocialLinkedin: require('/var/www/packages/theme/components/icons/social/Linkedin.vue').default,IconsSocialMail: require('/var/www/packages/theme/components/icons/social/Mail.vue').default,IconsSocialTwitter: require('/var/www/packages/theme/components/icons/social/Twitter.vue').default,AtomsSocialContactButton: require('/var/www/packages/theme/components/atoms/SocialContactButton.vue').default})
